var React = require('react');

function Ly (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M166.7-20h666.6v500H166.7z"}))),React.createElement("g",{"clipPath":"url(#a)","transform":"matrix(.96 0 0 .96 -160 19.2)","key":1},[React.createElement("path",{"fill":"#239e46","d":"M0-20h1000v500H0z","key":0}),React.createElement("path",{"d":"M0-20h1000v375H0z","key":1}),React.createElement("path",{"fill":"#e70013","d":"M0-20h1000v125H0z","key":2}),React.createElement("path",{"fill":"#fff","d":"M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z","key":3})])]);
}

Ly.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ly;

Ly.default = Ly;
